//src/services/publicReviews.api.js
import { apiRequest } from "./api";

export const getPublicProductReviews = () => {
  return apiRequest("/reviews");
};
